import { useState } from "react";
import { isSameColumnState } from "../columns/columnLayout";
import type { DataGridColumnState } from "../types";

const isSameOptionalState = (
    a: DataGridColumnState | undefined,
    b: DataGridColumnState | undefined,
) => (a && b ? isSameColumnState(a, b) : a === b);

/**
 * Keeps one `columnState` object while its values stay the same. The table
 * re-applies `columnState` whenever its identity changes, so a fresh but equal
 * object would echo back through `onColumnStateChange`.
 */
export const useStableColumnState = <
    TState extends DataGridColumnState | undefined,
>(
    columnState: TState,
): TState => {
    const [stable, setStable] = useState(columnState);
    if (stable !== columnState && !isSameOptionalState(stable, columnState)) {
        setStable(columnState);
        return columnState;
    }
    return stable;
};
